import { render, staticRenderFns } from "./AddQuestion.vue?vue&type=template&id=24ee4ffe&scoped=true"
import script from "./AddQuestion.vue?vue&type=script&lang=js"
export * from "./AddQuestion.vue?vue&type=script&lang=js"
import style0 from "./AddQuestion.vue?vue&type=style&index=0&id=24ee4ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ee4ffe",
  null
  
)

export default component.exports